import React from 'react';
class PanelAreaShowList extends React.Component {
    constructor(props) {
        super(props);
        this.onTouchTap = this.onTouchTap.bind(this);
    }
    componentDidMount() {
        this.refs.areaShowList.scrollLeft = this.refs.areaShowList.scrollWidth;
    }
    componentDidUpdate() {
        this.refs.areaShowList.scrollLeft = this.refs.areaShowList.scrollWidth;
    }
    onTouchTap(e) {
        this.props.deleteSelectArea(e.target.getAttribute('data-item-id') || e.target.parentElement.getAttribute('data-item-id'));
    }
    render() {
        const { selectAreas, translation } = this.props;
        return (
            <div className='area-show-list' ref='areaShowList'>
                {selectAreas.length > 0 ?
                    selectAreas.map((dataItem, index) => {
                        return (<span key={index}
                            className='area-show'
                            data-item-id={dataItem.Id}
                            onTouchTap={this.onTouchTap}
                        >
                            {dataItem.Name}
                            <span className="deletArea" onTouchTap={this.onTouchTap} />
                        </span>);
                    }) :
                    <span className="area-show-placeholder">{translation && translation.chooseAreaTip}</span>
                }
            </div>);
    }
}
export default PanelAreaShowList;



// WEBPACK FOOTER //
// ./src/components/Field_Components/PopArea/PanelAreaShowList.js